import { Event, EventProps } from './Event';
import { Leaderboard, LeaderboardProps } from '../competitions/Leaderboard';
import { Competition } from 'functions/src/types/firestore/Game/Competition';

export type ListItemCompetitionProps = (EventProps | LeaderboardProps) &
  Pick<Competition, 'type'>;

export function ListItemCompetition(props: ListItemCompetitionProps) {
  const { type } = props;

  return (
    <>
      {type === 'leaderboard' ? (
        <Leaderboard {...(props as LeaderboardProps)} />
      ) : (
        <Event {...(props as EventProps)} />
      )}
    </>
  );
}
